import { ChevronDown, Info } from "lucide-react";
import { ReactNode, useState } from "react";
import { Tooltip } from "@shared/ui";
import styles from "../styles.module.scss";

interface HubCollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  summary?: string;
  infoTooltip?: string;
  children: ReactNode;
}

export function HubCollapsibleSection({
  title,
  defaultOpen = true,
  summary,
  infoTooltip,
  children,
}: HubCollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={styles.hubSection}>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className={styles.hubSectionHeader}
      >
        <div className={styles.hubSectionTitleWrap}>
          <h4 className={styles.hubSectionTitle}>{title}</h4>
          {infoTooltip ? (
            <Tooltip title={infoTooltip}>
              <span className={styles.hubSectionInfo}>
                <Info size={14} />
              </span>
            </Tooltip>
          ) : null}
        </div>
        <div className={styles.hubSectionMeta}>
          {!open && summary ? (
            <span className={styles.hubSectionSummary}>{summary}</span>
          ) : null}
          <ChevronDown
            size={14}
            className={`${styles.hubSectionChevron} ${
              open ? styles.hubSectionChevronOpen : ""
            }`}
          />
        </div>
      </button>
      {open ? <div className={styles.hubSectionBody}>{children}</div> : null}
    </section>
  );
}
